module.exports = __webpack_public_path__ + "img/yxrwb37.148a77ea.png";